module.exports = __webpack_public_path__ + "static/learn_more-277f77637ec7e55a7e677d376e1581b1.png";